import { OrangeButton } from 'components/Button';
import styled from 'styled-components';

export const StyledOrangeButton = styled(OrangeButton)`
  && {
    margin-top: 24px;
  }
`;

export const WrapperBar = styled.div`
  && {
    margin-top: 10px;
  }
`;
